import React, { useState, useEffect, useCallback, lazy } from 'react';
import { useSelector } from 'react-redux';
import SMResult from 'components/Atoms/SMResult/SMResult';
import { find as _find, isEmpty as _isEmpty, isUndefined as _isUndefined } from 'lodash-es';
const AccessDeniedContainer = lazy(() => import(/* webpackChunkName: 'MainHeader' */ 'pages/AccessDeniedContainer'));

const PrivateRoute = ({ children, ...rest }) => {
  // * get navigation state from redux
  const Navigation = useSelector(state => state?.Navigation);
  const userData = useSelector(state => state?.User?.userData);
  const urlPermissionEnabledAccountForSupportUser =
    process.env.REACT_APP_URL_RESTRICTION_ENABLED_ACCOUNTS_FOR_SUPPORT_USER.split(',');

  // * this state is used to determine permission state of access. Type :: Boolean
  const [isAuthenticatedRoute, setIsAuthenticatedRoute] = useState(true);

  // * Function to calculate all authorization related work and update state with boolean flag of access
  const verifyAccessRoute = useCallback(() => {
    const isSupportUser = userData?.userName?.includes('[admin]');
    if (isSupportUser && !urlPermissionEnabledAccountForSupportUser.includes(userData?.merchantID)) {
      // Note: for our internal support user, no need to check permissions
      setIsAuthenticatedRoute(true);
    } else if (!_isEmpty(Navigation?.menu) && !_isEmpty(Navigation?.permissions)) {
      const foundMenuObj = _find(Navigation?.menu, item => item?.id === rest?.routeId) || {};
      let foundMenu = true;
      if (_isEmpty(foundMenuObj)) {
        foundMenu = false;
      }
      if (!foundMenu) {
        const permissions = Navigation?.permissions || {};
        if (!_isUndefined(permissions[rest?.routeId])) {
          foundMenu = permissions[rest?.routeId];
        } else {
          foundMenu = false;
        }
      }
      if (!foundMenu) {
        foundMenu = true;
      }
      setIsAuthenticatedRoute(foundMenu);
    }
  }, [
    Navigation?.menu,
    Navigation?.permissions,
    rest?.routeId,
    userData?.merchantID,
    userData?.userName,
    urlPermissionEnabledAccountForSupportUser
  ]);

  useEffect(() => {
    if (!Navigation?.loading && !Navigation?.error) {
      verifyAccessRoute();
    }
  }, [Navigation?.error, Navigation?.loading, verifyAccessRoute]);

  // * Loading state it menu api initiation is in progress
  if (Navigation?.loading && !Navigation?.error) {
    return <SMResult type='loading' message='loading routes' />;
  }

  // * Finally return route with render component based on access.
  return (
    isAuthenticatedRoute ? children : <AccessDeniedContainer /> 
  );
};

export default PrivateRoute;
